import { zergApi } from "@/service/zerg";

class AttendanceService {

    async getDailyAttendance(params) {
        try {
            const data = await zergApi.post("monitoring/attendance/get-daily-attendance", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async insertMat(params) {
        try {
            const data = await zergApi.post("insert-mat", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getAttendanceDetailByStatus(params) {
        try {
            const data = await zergApi.post("monitoring/attendance/get-attendance-detail-by-status", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getSelectHomeworkStatuses() {
        try {
            const data = await zergApi.post("setting/homework-status/get-select-homework-statuses");
            return data;
        } catch (error) {
            throw error;
        }
    }

    async savePersonalAttendance(params) {
        try {
            const data = await zergApi.post("monitoring/attendance/save-personal-attendance", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getAttendanceOfToday(params) {
        try {
            const data = await zergApi.post("monitoring/attendance/get-attendance-of-today", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async saveComment(params) {
        try {
            const data = await zergApi.post("monitoring/attendance/save-comment", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async saveDriverComment(params) {
        try {
            const data = await zergApi.post("monitoring/attendance/save-driver-comment", params);
            return data;
        } catch (error) {
            throw error;
        }
    }
}

export default new AttendanceService();